import React, { Component } from 'react';
import { ButtonGroup } from '../buttonGroup/buttonGroup';
import Graph from './bySourceAllGraph';
import Table from './bySourceAllTable';
import trans from '../../translations.json';
import dict from '../../dictionary';

const viewModes = {
  graph: 'graph',
  table: 'table',
};

class Index extends Component {
  state = {
    selectedViewMode: viewModes.graph,
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <Graph
              chartTitle={trans.bySource.title[this.props.lang]}
              selectedTab={this.props.selectedTab}
              lang={this.props.lang}
            />
          );
        case viewModes.table:
          return (
            <Table
              selectedTab={this.props.selectedTab}
              lang={this.props.lang}
            />
          );
        default:
      }
    };

    return (
      <div id="">
        {this.props.selectedTab === dict.tabs.newCases ? (
          <p>
            {trans.bySource.descAllDaily[this.props.lang]}{' '}
            <a
              href={
                this.props.lang === 'en'
                  ? '/data/covid-19-case-data-glossary#infection-source'
                  : '/fr/data/donnees-sur-les-cas-de-covid-19-glossaire#infection-source'
              }
            >
              {trans.bySource.link[this.props.lang]}
            </a>
          </p>
        ) : (
          <p>
            {trans.bySource.descAllCumul[this.props.lang]}{' '}
            <a
              href={
                this.props.lang === 'en'
                  ? '/data/covid-19-case-data-glossary#infection-source'
                  : '/fr/data/donnees-sur-les-cas-de-covid-19-glossaire#infection-source'
              }
            >
              {trans.bySource.link[this.props.lang]}
            </a>
          </p>
        )}

        <>
          <ButtonGroup
            selected={this.state.selectedViewMode}
            viewModes={viewModes}
            lang={this.props.lang}
            handleOnClick={this.onViewModeChange}
          />
          <GetRightView />
        </>
      </div>
    );
  }
}
export default Index;
